import React from 'react'
import { Scatter, Interaction } from '@antv/g2plot'
import Box from '@mui/material/Box'
import * as d3 from 'd3'
import { NObject } from '@/@core/components/filter-variants'

const Scatters = React.forwardRef((props: any, ref) => {
  const his = React.useRef<HTMLElement | string>('')
  const plot = React.useRef<Scatter>()

  // const data: any[] = [props.value[0]]
  const data: any[] = props.value

  const colorScale = (index: string | number) => {
    const dataColors: NObject = {
      '1': '#ec5e64',
      '2': '#f1966f',
      '3': '#f6b360',
      '4': '#fcd756',
      '5': '#faf360',
      '6': '#dbe565',
      '7': '#acd274',
      '8': '#64c37c',
      '9': '#56b47b',
      '10': '#5ab694',
      '11': '#5bb9b2',
      '12': '#55b9d1',
      '13': '#6cbae4',
      '14': '#61a5d6',
      '15': '#5b91c7',
      '16': '#577cb5',
      '17': '#696ba3',
      '18': '#8b68a5',
      '19': '#ad65a4',
      '20': '#ce5ea4',
      '21': '#e377c2',
      '22': '#e5116b',
      X: '#ff7f0e',
      Y: '#d62728'
    }

    return dataColors[index]
  }

  React.useEffect(() => {
    const dom = document.getElementById('container-scatter')

    if (dom) {
      const width = dom.clientWidth
      const height = dom.clientHeight
      const margin = { top: 5, right: 25, bottom: 25, left: 25 }
      const h = height - margin.top - margin.bottom
      const w = width - margin.left - margin.right

      const svg = d3.create('svg').attr('width', width).attr('height', height)

      let sumAVG = 0

      for (const i in data) {
        const item = data[i]

        sumAVG += parseInt(item.avg)
      }

      const avgVariant = sumAVG / data.length

      // const formatPercent = d3.format('.%')

      const xScale = d3
        .scaleLinear()
        .domain([
          Number(
            d3.min([
              0,
              Number(
                d3.min(data, function (d) {
                  return 0
                })
              )
            ])
          ),
          Number(d3.max([0, data.length + 10]))
        ])
        .range([0, w])
      const yScale = d3
        .scaleLinear()
        .domain([
          Number(
            d3.min([
              0,
              Number(
                d3.min(data, function (d) {
                  return 0
                })
              )
            ])
          ),
          avgVariant * 8
        ])
        .range([h, 0])

      // add the tooltip area to the webpage
      const tooltip = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('background-color', '#000000c7')
        .style('color', '#fff')
        .style('opacity', 0)
        .style('padding', '3px')
        .style('border-radius', '6px')

      // X-axis
      const xAxis = d3.axisBottom(xScale).ticks(0)

      // Y-axis
      const yAxis = d3.axisLeft(yScale).ticks(5)

      svg
        .append('g')
        .attr('class', 'axis')
        .attr('transform', 'translate(0,' + h + ')')
        .attr('id', `xg`)
        .call(xAxis)
        .append('text') // X-axis Label
        .attr('class', 'label')
        .attr('y', 25)
        .attr('x', w)
        .attr('text-anchor', 'end') // 或者 "middle" 或 "end"，根据需要调整
        .style('font-size', '14px')
        .style('fill', 'black')
        .text('Chromosome')

      // Y-axis
      svg
        .append('g')
        .attr('class', 'axis')
        .attr('id', `yg`)
        .call(yAxis)
        .append('text') // y-axis Label
        .attr('class', 'label')
        .attr('transform', 'rotate(-90)')
        .attr('x', 0)
        .attr('y', 12)
        .attr('text-anchor', 'end') // 或者 "middle" 或 "end"，根据需要调整
        .style('font-size', '14px')
        .style('fill', 'black')
        .text('Reads Depth')

      const circles = svg
        .selectAll('circle')
        .data(data)
        .enter()
        .append('circle')
        .attr('cx', function (d) {
          return xScale(d.index)
        })
        .attr('cy', function (d) {
          return yScale(d.avg)
        })
        .attr('r', '1.2')
        .attr('fill', function (d, i) {
          if (d && d.chrom && d.chrom.includes('chr'))
            return colorScale(d.chrom.split('chr')[1])
          else return colorScale(d?.chrom)
        })
        .on('mouseover', function (d, v) {
          tooltip
            .transition()
            .duration(200)
            .style('position', 'absolute')
            .style('opacity', 0.9)
            .style('z-index', 99)
            .style('font-size', '10px')
            .style('top', `${d.pageY}px`)
            .style('left', `${d.pageX + 20}px`)

          tooltip.html(
            v.chrom +
              ':' +
              v.start +
              '-' +
              v.end +
              '<br>Average: ' +
              v.avg +
              ' Length: ' +
              v.length
          )
        })
        .on('mouseout', function () {
          tooltip
            .transition()
            .duration(500)
            .style('opacity', 0)
            .style('z-index', -99)
        })
      const nodes = dom.children

      Array.from(nodes).map((item) => dom.removeChild(item))

      dom.append(svg.node() as SVGSVGElement)
      const xgDom = document.getElementById(
        'xg'
      ) as unknown as SVGGraphicsElement
      const ygDom = document.getElementById(
        'yg'
      ) as unknown as SVGGraphicsElement
      const xgParams = xgDom.getBBox()
      const ygParams = ygDom.getBBox()

      svg.attr('viewBox', [
        0,
        0,
        Math.max(xgParams.width, ygParams.width),
        height
      ])

      // X-axis
      let firstChrom = data[0].chrom.includes('chr')
        ? data[0].chrom.split('chr')[1]
        : data[0].chrom
      let currentPos = 0 as any
      let lastChrom = data[0].chrom.includes('chr')
        ? data[0].chrom.split('chr')[1]
        : data[0].chrom
      let lastPos = data[0].index

      for (const i in data) {
        const item = data[i]

        const chrom = item.chrom.includes('chr')
          ? item.chrom.split('chr')[1]
          : item.chrom

        if (firstChrom != chrom) {
          svg
            .append('text')
            .attr('class', 'label')
            .attr('transform', 'translate(0,' + h + ')')
            .attr('y', 6)
            .attr(
              'x',
              xScale(
                parseInt(item.index) -
                  (parseInt(item.index) - parseInt(currentPos)) / 2
              ) + 5
            )
            .attr('dy', '.71em')
            .style('text-anchor', 'end')
            .style('font-size', '12px')
            .style('font-weight', '600')

            //.attr('dy','.71em')
            .text(firstChrom)

          firstChrom = chrom

          currentPos = item.index
        }

        lastChrom = chrom

        lastPos = item.index
      }

      svg
        .append('text')
        .attr('class', 'label')
        .attr('transform', 'translate(0,' + h + ')')
        .attr('y', 6)
        .attr(
          'x',
          xScale(
            parseInt(lastPos) - (parseInt(lastPos) - parseInt(currentPos)) / 2
          ) + 5
        )
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .style('font-size', '12px')
        .style('font-weight', '600')
        .text(lastChrom)
    }
  }, [])

  return (
    <Box
      position={'relative'}
      id="container-scatter"
      width={'100%'}
      ref={his}
      height={'100%'}
      minHeight={'220px'}
    ></Box>
  )
})

export default Scatters
